import MainLayout from 'layout/MainLayout';
import NotFoundPage from 'pages/NotFoundPage';
import RoamingPage from 'pages/RoamingPage';
import React from 'react';
import { RouteObject } from 'react-router-dom';

/** @type {RouteObject[]} */
const Routes = [
  {
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <RoamingPage />,
      },
      {
        path: '/*',
        element: <NotFoundPage />,
      },
    ],
  },
];
export default Routes;
